module.exports = __webpack_public_path__ + "img/photo-06.a19b5ac8.webp";